import React, { Component } from "react";
import { Text, StyleSheet ,Platform} from "react-native";

class TextView extends Component {
  render() {
    return <Text numberOfLines={this.props.numberOfLines} style={[this.props.isbold ? styles.textBold : styles.text, this.props.style]} {...this.props.rest}>
      {this.props.children}
    </Text>
  }
}

const styles = StyleSheet.create({
  text: {
    fontFamily: 'IRANSansMobile',
  },
  textBold: {
    fontFamily: 'IRANSansMobile',
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal'
  },
});
export default TextView;
